import React, { ReactNode } from "react"

type TextComponentProps = {
  children: ReactNode
  className?: string
}

const Text: React.FC<TextComponentProps> = ({ children, className }) => {
  return <p className={`text-gray-500 dark:text-gray-300 ${className}`}>{children}</p>
}

export default Text
